// extracted by mini-css-extract-plugin
module.exports = {"navs":"Detail_navs__1YdB7","nav":"Detail_nav__26RJb","act":"Detail_act__2tmtL"};